import { useNavigate } from "@solidjs/router";
import {
  Accessor,
  Match,
  Setter,
  Switch,
  createSignal,
  onMount,
} from "solid-js";
import { Show, getRequestEvent } from "solid-js/web";
import { setAuth } from "~/data/auth";
import { config } from "~/data/config";
import { Product } from "~/server/types/search";
import { Cookie, Mode } from "~/types";
import { getCookie } from "~/utils/client_cookie";
import { Spacer } from "~/widgets/spacer";
import { zIndexes } from "~/z_indexes";
import { HeaderMenu } from "./header_menu";
import { Search, getSearchResults } from "../search/search";
import { BusinessMenuCta } from "../business_menu";
import { CoinsPillOrBranding } from "./coinspill_or_branding";
import { AxisHeader } from "~/components/header/header_axis";
import { IciciIndriyaHeader } from "~/components/header/header_icici_indriya";
import { AuthMethod } from "~/server/types/client";
import { clientIdConfig } from "~/data/partner_config";
import {
  CloseIcon,
  MagnifyingGlass,
  MenuIcon,
} from "~/assets/svg_icons/svg_icons";
import { useWebStoreContext } from "~/context/webstore_context";
import { tataDigitalFaqs } from "~/data/partner_faqs/tata_faqs";

type HeaderProps = {
  headerImageUrl?: string;
  userName?: string;
  authMethod: AuthMethod;
  offerConstructAvailed?: Accessor<boolean | undefined>;
  isSearchActive: Accessor<boolean>;
  setIsSearchActive: Setter<boolean>;
};

export function CustomHeaderOldDS(props: HeaderProps) {
  let headerImageHref = config.paths.homePageUrl;
  let headerImageUrl = props.headerImageUrl;
  const { isSearchActive, setIsSearchActive } = props;

  const webStoreContext = useWebStoreContext();
  const [clearSearch, setClearSearch] = createSignal(false);
  const [allBrands, setAllBrands] = createSignal<Product[]>(
    webStoreContext?.storeState.brands ?? []
  );
  const [isDropdownOpen, setIsDropdownOpen] = createSignal<boolean>(false);
  const [headerButtonRef, setHeaderButtonRef] = createSignal<HTMLDivElement>();

  const [isBusinessDropdownOpen, setIsBusinessDropdownOpen] =
    createSignal<boolean>(false);

  const { getMode, getClientId } = useWebStoreContext();

  onMount(async () => {
    setAllBrands(
      webStoreContext?.storeState.brands ??
      (await getSearchResults(
        "",
        { filterOutInactive: false },
        { pageNo: 0, limit: 30 }
      ))
    );

    const sid = getCookie(Cookie.SessionId);
    if (sid) {
      setAuth(() => {
        return {
          sessionId: sid,
        } as any;
      });
    }

    const requestEvent = getRequestEvent();
    if (requestEvent?.locals.logoUrl) {
      headerImageUrl = requestEvent.locals.logoUrl;
    }
  });

  function showBranding() {
    if (getClientId() === clientIdConfig.raisoniClientId) return true;
    if (getClientId() === clientIdConfig.nielsenClientId) return true;
    if (getClientId() === clientIdConfig.tdClientId) return true;
    return false;
  }

  function GetSearchBar(props: { title?: string }) {
    return (
      <Search
        setIsSearchActive={setIsSearchActive}
        setClearSearch={setClearSearch}
        clearSearch={clearSearch}
        isSearchActive={isSearchActive}
        allBrands={allBrands}
        title={props.title}
      />
    );
  }

  function LoginButton() {
    return (
      <div
        class="shadow flex h-10 w-fit cursor-pointer flex-row items-center justify-center rounded-[30px] border border-neutral-800 bg-baseTertiaryLight px-[10px]"
        onClick={() => {
          webStoreContext.loginToWebstore(() => { });
        }}
      >
        <div class="px-[3.61px] text-center text-mediumBold text-textDark">
          Log in / Sign up
        </div>
      </div>
    );
  }

  function buildHeaderMenu() {
    const { storeState } = useWebStoreContext();
    return (
      <HeaderMenu
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
        isLoggedIn={storeState.isLoggedIn}
        mode={getMode()}
        headerButtonRef={headerButtonRef}
        clientId={() => getClientId()}
        partnerPortalTncUrl={"/tnc/tata-neu"}
        fAQsInHeader={tataDigitalFaqs}
        showBusinessMenu={getMode() === "hubble"}
      />
    );
  }

  function buildMenuButtonListIcon() {
    return (
      <div
        id="toggle-header-menu-mobile"
        class="h-[26px] w-[26px] cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsDropdownOpen(!isDropdownOpen());
        }}
        tabIndex="0"
        ref={setHeaderButtonRef}
      >
        <Show
          when={isDropdownOpen()}
          fallback={<MenuIcon height={26} width={26} />}
        >
          <CloseIcon height={26} width={26} />
        </Show>
      </div>
    );
  }

  function buildSearchIcon() {
    return (
      <div
        class="cursor-pointer"
        onClick={() => {
          setIsSearchActive(!isSearchActive());
        }}
      >
        <MagnifyingGlass />
      </div>
    );
  }

  function TataDigitalLoggedInHeader() {
    return (
      <div
        class="sticky top-0 w-full bg-baseTertiaryLight darkTheme:border-b darkTheme:border-[#333232] sm:h-[77px]"
        style={{
          "z-index": zIndexes.header,
        }}
        classList={{
          "!h-[52px] sm:!h-[77px]": true,
        }}
      >
        <div class="flex flex-col items-center">
          <div class="ml-4 mr-4 flex w-full flex-row items-center justify-between px-4 py-3 lg:mx-4 lg:max-w-[1136px] lg:px-0 lg:py-4">
            <div
              class={`absolute left-0 right-0  h-screen w-full  bg-baseDark transition-all duration-300 darkTheme:bg-black md:top-20 ${isSearchActive() || isDropdownOpen() || isBusinessDropdownOpen() ? "pointer-events-none opacity-40" : "pointer-events-none opacity-0"} ${isSearchActive() ? "top-32" : "top-20"} `}
            />
            <div class="w-fit lg:w-[286px]">
              <HeaderLogo
                imageUrl={headerImageUrl}
                imageHref={headerImageHref}
                mode={getMode()}
                width={"146px"}
                height={"28px"}
              />
            </div>
            <Show when={true}>
              <>
                <div class="hidden md:flex">
                  <GetSearchBar />
                </div>
                <div class="flex flex-row items-center justify-end text-textDark lg:w-[286px]">
                  <Show
                    when={
                      getMode() === "hubble" &&
                      !webStoreContext.storeState.isLoggedIn
                    }
                  >
                    <div class="hidden md:flex">
                      <BusinessMenuCta
                        setIsDropdownOpen={setIsBusinessDropdownOpen}
                        isDropdownOpen={isBusinessDropdownOpen}
                      />
                    </div>
                  </Show>
                  <Spacer width={16} />
                  <Show when={webStoreContext.storeState.isLoggedIn}>
                    <div
                      classList={{
                        "hidden sm:flex": false,
                      }}
                    >
                      <CoinsPillOrBranding
                        mode={getMode()}
                        showRedeemCodeCta={props.authMethod !== "CODE"}
                        showCoins={() =>
                          webStoreContext.webstoreUIConfig().showCoins
                        }
                        userName={props.userName}
                        coins={webStoreContext.storeState.coins ?? 0}
                        showBranding={showBranding()}
                        showVerticalBranding={true}
                      />
                    </div>
                  </Show>
                  <Spacer width={16} />
                  <Switch>
                    <Match when={!webStoreContext.storeState.isLoggedIn}>
                      <div class="hidden lg:inline-flex">
                        <LoginButton />
                      </div>
                    </Match>
                    <Match when={true}>{buildHeaderMenu()}</Match>
                  </Switch>
                  <div class="lg:hidden">
                    <Show when={!webStoreContext.storeState.isLoggedIn}>
                      {buildHeaderMenu()}
                    </Show>
                  </div>
                  <div
                    class="mr-3 md:hidden"
                    classList={{
                      "mr-2": true,
                    }}
                  >
                    <div>{buildSearchIcon()}</div>
                  </div>
                  <div class="lg:hidden">{buildMenuButtonListIcon()}</div>
                </div>
              </>
            </Show>
          </div>
          <div class="flex w-full flex-row items-center justify-center md:hidden">
            <Show when={isSearchActive()}>
              <GetSearchBar />
            </Show>
          </div>
          {/* // looks deprecated */}
        </div>
      </div>
    );
  }

  function getAxisHeader() {
    const hideSearchBar = () => allBrands().length == 1;
    return (
      <AxisHeader
        isLoggedIn={webStoreContext.storeState.isLoggedIn}
        mode={getMode()}
        coins={webStoreContext.storeState.coins ?? 0}
        showCoins={() => false}
        isSearchActive={isSearchActive}
        setIsSearchActive={setIsSearchActive}
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
        clientId={getClientId()}
        hideSearchBar={hideSearchBar()}
        showMyGiftCards={getClientId() !== clientIdConfig.indriyaClientId}
        buildSearchBar={() => {
          if (hideSearchBar()) {
            return <></>;
          }
          return <GetSearchBar title="Search for brands" />;
        }}
      />
    );
  }

  function getIciciIndriyaHeader() {
    return (
      <IciciIndriyaHeader
        isLoggedIn={webStoreContext.storeState.isLoggedIn}
        mode={getMode()}
        clientId={getClientId()}
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
      />
    );
  }

  return (
    <Switch>
      <Match when={getClientId() === clientIdConfig.iciciIndriyaClientId}>
        {getIciciIndriyaHeader()}
      </Match>
      <Match when={getClientId() === clientIdConfig.axisClientId || getClientId() === clientIdConfig.indriyaClientId}>
        {getAxisHeader()}
      </Match>
      <Match when={true}>
        <TataDigitalLoggedInHeader />
      </Match>
    </Switch>
  );
}

type HeaderLogoProps = {
  mode: Mode; // need this to determine image's height
  imageUrl?: string;
  imageHref: string;
  height?: string;
  width?: string;
};

function HeaderLogo(props: HeaderLogoProps) {
  const navigate = useNavigate();

  return (
    <img
      class="cursor-pointer"
      classList={{
        "h-[36px] lg:h-[48px]": props.mode === "rnr",
        "h-[24px] ": props.mode !== "rnr",
      }}
      style={{
        height: props.height,
        width: props.width,
      }}
      src={
        props.imageUrl ??
        "https://s3.ap-south-1.amazonaws.com/assets.hubble/web-assets/hubble_full.svg"
      }
      alt="Hubble Logo"
      onClick={() => {
        navigate(props.imageHref);
      }}
    />
  );
}
